/***
 * Created on 2023/9/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import {useProfile} from "../../hook/hooks";
import {useTogglePopup} from "../../hook/toggle_popup";
import {useTranslation} from "react-i18next";
import {getPrimaryQid} from "../../service/user";

function AccountHeader(props) {
    const { t } = useTranslation();
    const {profile} = useProfile();
    const {isShow, toggleAction, elemRef} = useTogglePopup();

    const handleAvatar404 = (e, name) => {
        const parent_element = e.target.parentElement;
        const new_child = document.createElement('span');
        new_child.textContent = name;
        parent_element.appendChild(new_child);
        e.target.remove();
    }

    const signout = () => {
        window.location.replace(`/signout${location.search}`);
    }

    useEffect(() => {
        const appHead = document.querySelector('.app-head');
        if (!isShow) {
            appHead.removeAttribute('data-z-index');
            appHead.style.zIndex = null;
        }
        else {
            appHead.setAttribute('data-z-index', 'top');
            appHead.style.zIndex = 501;
        }
    }, [isShow])

    return (
         profile && profile?.user_id &&
            <>
                <div className="divide"/>
                <div className={`util-btn ${isShow ? 'active' : ''}`} util-type="account" ref={elemRef} onClick={toggleAction} data-testid="account-header">
                    <div className="comp-avatar no-avatar">
                        {
                            profile?.avatars?.medium && profile.avatars?.medium?.length > 0 &&
                            <img src={profile.avatars.medium} alt="avatar-icon"
                                 onError={e => handleAvatar404(e, profile?.display_name[0])}/> ||
                            <span>{profile?.display_name[0]}</span>
                        }
                    </div>

                    <div className="comp-dropdown hide" data-modal-sheet>
                        <ul className="dropdown-menu">
                            <li className="dropdown-menu__head">{t('@Account Management@')}</li>
                            <li className="dropdown-menu__item">
                                <div className="dropdown-menu__item-group">
                                    <div className="w-48px min-w-48px flex-initial">
                                        <div className="comp-avatar no-avatar !w-48px !h-48px">
                                            {
                                                profile?.avatars?.medium && profile.avatars?.medium?.length > 0 &&
                                                <img src={profile.avatars.medium} alt="avatar"
                                                     onError={e => handleAvatar404(e, profile?.display_name[0])}/> ||
                                                <span>{profile?.display_name[0]}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="flex-1 min-w-0 pl-16">
                                        <div
                                            className="text-16 font-medium overflow-hidden text-overflow-ellipsis white-space-nowrap">
                                            {
                                                profile?.display_name
                                            }
                                        </div>
                                        <div
                                            className="text-14 color-gray overflow-hidden text-overflow-ellipsis white-space-nowrap">
                                            {getPrimaryQid(profile)}
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="dropdown-menu__divider !mt-10 !mb-10"></li>
                            <li className="dropdown-menu__item cursor-pointer" onClick={signout}>{t('@Sign out@')}</li>
                        </ul>
                    </div>
                </div>
            </>
    );
}

export default AccountHeader;